import React from 'react';

function ButtonSpacer(): JSX.Element {
  return <div className='button-spacer' style={{ padding: '5px 0' }} />;
}

ButtonSpacer.displayName = 'ButtonSpacer';

export default ButtonSpacer;
